(function () {
  'use strict';
  var d = document;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(sel, ctx) { return (ctx || d).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  /* ---------- Menú lateral ---------- */
  var drawer = qs('[data-drawer]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    d.body.classList.toggle('no-scroll', open);
    qsa('.hdr-burger').forEach(function (b) { b.setAttribute('aria-expanded', open); });
  }

  /* ---------- Buscador ---------- */
  var panel = qs('[data-search-panel]');
  var backdrop = qs('.search-backdrop');
  var input = qs('[data-search-input]');
  var results = qs('[data-search-results]');
  var suggest = qs('[data-search-suggest]');
  var closeTimer;

  function setSearch(open) {
    if (!panel) return;
    clearTimeout(closeTimer);
    qsa('[data-search-toggle][aria-expanded]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
    if (open) {
      [panel, backdrop].forEach(function (el) {
        if (!el) return;
        el.hidden = false;
        el.setAttribute('data-state', 'closed');
        void el.offsetWidth;
        el.setAttribute('data-state', 'open');
      });
      d.body.classList.add('no-scroll');
      setTimeout(function () { if (input) input.focus(); }, 30);
    } else {
      [panel, backdrop].forEach(function (el) { if (el) el.setAttribute('data-state', 'closed'); });
      d.body.classList.remove('no-scroll');
      closeTimer = setTimeout(function () {
        panel.hidden = true;
        if (backdrop) backdrop.hidden = true;
      }, reduceMotion ? 0 : 260);
    }
  }
  function searchOpen() { return panel && !panel.hidden && panel.getAttribute('data-state') === 'open'; }

  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-toggle]')) {
      setDrawer(!(drawer && drawer.classList.contains('is-open')));
    } else if (e.target.closest('[data-search-toggle]')) {
      e.preventDefault();
      setSearch(!searchOpen());
    }
  });
  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (searchOpen()) setSearch(false);
    if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
  });

  /* Resultados mientras escribe */
  function money(value) {
    var n = Number(value);
    if (isNaN(n)) return value;
    return '$' + n.toLocaleString('es-CO', { maximumFractionDigits: 0 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var searchTimer, searchCtrl;
  if (input && results && window.MB && window.MB.searchUrl) {
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(searchTimer);
      if (searchCtrl) searchCtrl.abort();
      if (q.length < 2) { results.innerHTML = ''; if (suggest) suggest.hidden = false; return; }
      searchTimer = setTimeout(function () {
        searchCtrl = 'AbortController' in window ? new AbortController() : null;
        var url = window.MB.searchUrl + '.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, searchCtrl ? { signal: searchCtrl.signal } : {})
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (suggest) suggest.hidden = true;
            if (!items.length) {
              results.innerHTML = '<p class="sr-empty">No encontramos resultados para “' + esc(q) + '”. Prueba con otra palabra.</p>';
              return;
            }
            var html = '<ul class="sr-list">' + items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
              var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
              return '<li><a class="sr-item" href="' + esc(p.url) + '">' +
                '<span class="sr-media">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + '</span>' +
                '<span class="sr-title">' + esc(p.title) + '</span>' +
                '<span class="sr-price">' + esc(money(p.price)) + '</span></a></li>';
            }).join('') + '</ul>' +
              '<a class="link-arrow sr-all" href="/search?type=product&q=' + encodeURIComponent(q) + '">Ver todos los resultados</a>';
            results.innerHTML = html;
          })
          .catch(function (err) { if (err.name !== 'AbortError') results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- Encabezado al hacer scroll ---------- */
  var header = qs('[data-header]');
  if (header) {
    var sentinel = d.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:1px;';
    d.body.prepend(sentinel);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        header.classList.toggle('is-scrolled', !entries[0].isIntersecting);
      }, { rootMargin: '40px 0px 0px 0px' }).observe(sentinel);
    }
  }

  /* ---------- Barra de anuncio rotativa ---------- */
  qsa('[data-announce]').forEach(function (bar) {
    var msgs = qsa('.announce-msg', bar);
    if (msgs.length < 2) return;
    var i = 0, timer;
    bar.classList.add('is-rotating');
    msgs[0].classList.add('is-current');
    function next() {
      msgs[i].classList.remove('is-current');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-current');
    }
    function start() { stop(); timer = setInterval(next, 4500); }
    function stop() { clearInterval(timer); }
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    d.addEventListener('visibilitychange', function () { d.hidden ? stop() : start(); });
    start();
  });

  /* ---------- Entrada al hacer scroll ---------- */
  var reveals = qsa('[data-reveal]');
  if (reveals.length) {
    if (!('IntersectionObserver' in window) || reduceMotion) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  /* ---------- Contador del carrito ---------- */
  function setCount(n) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  /* ---------- Aviso ---------- */
  var toastTimer;
  function toast(msg, ok) {
    var old = qs('.toast'); if (old) old.remove();
    var t = d.createElement('div');
    t.className = 'toast' + (ok ? '' : ' toast--err');
    t.setAttribute('role', 'status');
    var span = d.createElement('span');
    span.textContent = msg;
    t.appendChild(span);
    if (ok) {
      var a = d.createElement('a');
      a.href = window.MB.cartUrl; a.textContent = 'Ver carrito';
      t.appendChild(a);
    }
    d.body.appendChild(t);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.remove(); }, 4000);
  }

  /* ---------- Carrito lateral ---------- */
  var cdrawer = qs('[data-cart-drawer]');
  var lastFocus;
  function setCart(open) {
    if (!cdrawer) return false;
    if (open) lastFocus = d.activeElement;
    cdrawer.classList.toggle('is-open', open);
    cdrawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    d.body.classList.toggle('no-scroll', open);
    if (open) {
      var close = qs('[data-cart-close].hdr-icon', cdrawer);
      if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 60);
    } else if (lastFocus && lastFocus.focus) {
      lastFocus.focus({ preventScroll: true });
    }
    return true;
  }
  function cartOpen() { return cdrawer && cdrawer.classList.contains('is-open'); }

  /* Vuelve a pintar el carrito lateral con la API de secciones */
  function renderCart(html) {
    var wrap = qs('#shopify-section-cart-drawer');
    if (!wrap || !html) return;
    var tmp = d.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-cart-drawer');
    if (fresh) wrap.innerHTML = fresh.innerHTML;
  }
  function refreshCart() {
    return Promise.all([
      fetch(window.MB.cartJs).then(function (r) { return r.json(); }),
      fetch(window.location.pathname + '?sections=cart-drawer').then(function (r) { return r.json(); })
    ]).then(function (res) {
      setCount(res[0].item_count);
      renderCart(res[1]['cart-drawer']);
      return res[0];
    });
  }

  function addToCart(body, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); if (btn.classList.contains('btn')) { btn.disabled = true; btn.textContent = 'Agregando…'; } }
    return fetch(window.MB.addUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || 'No pudimos agregar el producto. Inténtalo de nuevo.');
        return refreshCart();
      })
      .then(function () {
        closeQuickAdd();
        if (!setCart(true)) toast('Agregado al carrito', true);
      })
      .catch(function (err) { toast(err.message, false); })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); if (btn.classList.contains('btn')) { btn.disabled = false; btn.innerHTML = label; } }
      });
  }

  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]')) return;
    e.preventDefault();
    addToCart(new FormData(form), form.querySelector('[type=submit]'));
  });

  d.addEventListener('click', function (e) {
    var t = e.target;
    /* Ícono del carrito en el encabezado: abre el panel (salvo en la página del carrito) */
    var cartLink = t.closest('.hdr-cart, .mnav a[href$="/cart"]');
    if (cartLink && cdrawer && !d.body.classList.contains('template-cart')) {
      e.preventDefault();
      setCart(true);
      return;
    }
    if (t.closest('[data-cart-close]')) { setCart(false); return; }

    /* Cambiar cantidad o quitar */
    var lineBtn = t.closest('[data-cart-line]');
    if (lineBtn) {
      var body = qs('[data-cart-body]');
      if (body) body.setAttribute('aria-busy', 'true');
      fetch(window.MB.cartUrl + '/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(lineBtn.getAttribute('data-cart-line')), quantity: Number(lineBtn.getAttribute('data-qty')) })
      })
        .then(function (r) { if (!r.ok) throw new Error('No pudimos actualizar el carrito.'); return refreshCart(); })
        .catch(function (err) { toast(err.message, false); var b = qs('[data-cart-body]'); if (b) b.removeAttribute('aria-busy'); });
      return;
    }

    /* Agregar rápido: abrir tallas */
    var open = t.closest('[data-qa-open]');
    if (open) {
      var qa = open.closest('[data-qa]');
      var isOpen = qa.classList.contains('is-open');
      closeQuickAdd();
      if (!isOpen) openQuickAdd(qa);
      return;
    }
    if (t.closest('[data-qa-close]')) { closeQuickAdd(); return; }
    var size = t.closest('[data-qa-add]');
    if (size) {
      var fd = new FormData();
      fd.append('id', size.getAttribute('data-qa-add'));
      fd.append('quantity', '1');
      addToCart(fd, size);
      return;
    }
    if (!t.closest('[data-qa]')) closeQuickAdd();
  });

  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cartOpen()) setCart(false);
    closeQuickAdd();
  });

  /* ---------- Agregar rápido (tallas) ---------- */
  var qaTimer;
  function openQuickAdd(qa) {
    var panel = qs('[data-qa-panel]', qa);
    if (!panel) return;
    clearTimeout(qaTimer);
    qa.classList.add('is-open');
    qs('[data-qa-open]', qa).setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.setAttribute('data-state', 'closed');
    void panel.offsetWidth;
    panel.setAttribute('data-state', 'open');
  }
  function closeQuickAdd() {
    qsa('[data-qa].is-open').forEach(function (qa) {
      var panel = qs('[data-qa-panel]', qa);
      qa.classList.remove('is-open');
      qs('[data-qa-open]', qa).setAttribute('aria-expanded', 'false');
      if (!panel) return;
      panel.setAttribute('data-state', 'closed');
      qaTimer = setTimeout(function () { panel.hidden = true; }, reduceMotion ? 0 : 200);
    });
  }

  /* ---------- Cambio de talla / variante ---------- */
  d.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-variant-select]') : null;
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var price = qs('[data-price]'), compare = qs('[data-compare]'), add = qs('[data-add-btn]');
    if (price) price.textContent = opt.getAttribute('data-price');
    if (compare) {
      var c = opt.getAttribute('data-compare');
      compare.textContent = c || '';
      compare.hidden = !c;
    }
    if (add) add.disabled = opt.disabled;
  });
})();

/* ---------- Banners que rotan ---------- */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  Array.prototype.forEach.call(document.querySelectorAll('[data-slideshow]'), function (root) {
    var slides = root.querySelectorAll('.bfs-slide');
    var dots = root.querySelectorAll('.bfs-dot');
    if (slides.length < 2) return;
    var i = 0, timer;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce;
    var ms = (Number(root.getAttribute('data-speed')) || 6) * 1000;
    function go(n) {
      slides[i].classList.remove('is-active');
      if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      if (dots[i]) dots[i].classList.add('is-active');
    }
    function start() { stop(); if (auto) timer = setInterval(function () { go(i + 1); }, ms); }
    function stop() { clearInterval(timer); }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-slide-next]')) { go(i + 1); start(); }
      else if (e.target.closest('[data-slide-prev]')) { go(i - 1); start(); }
      else {
        var dot = e.target.closest('[data-slide-to]');
        if (dot) { go(Number(dot.getAttribute('data-slide-to'))); start(); }
      }
    });
    /* Deslizar con el dedo */
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null; start();
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
    /* En el editor: mostrar el banner que se selecciona */
    document.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target);
      if (idx > -1) { stop(); go(idx); }
    });
    start();
  });
})();

/* ---------- Sugerencias de productos ---------- */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-recs]'), function (root) {
    var url = root.getAttribute('data-url');
    if (!url || !('fetch' in window)) return;
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var grid = tmp.querySelector('[data-recs-grid]');
        if (!grid || !grid.children.length) return;
        root.querySelector('[data-recs-grid]').innerHTML = grid.innerHTML;
        root.querySelector('[data-recs-wrap]').hidden = false;
      })
      .catch(function () {});
  });
})();

/* ---------- Comparador automático de precios ---------- */
(function () {
  var box = document.querySelector('[data-live-compare]');
  if (!box || !('fetch' in window)) return;
  function fmt(c) { return '$' + Math.round(c).toLocaleString('es-CO'); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  var url = box.getAttribute('data-endpoint') + '?t=' + encodeURIComponent(box.getAttribute('data-t')) + '&g=' + encodeURIComponent(box.getAttribute('data-g') || '');
  var key = box.getAttribute('data-key');
  var offers = [];

  function render(oursCents) {
    var ours = oursCents / 100;
    if (!offers.length) { box.hidden = true; return; }
    var prices = offers.map(function (o) { return o.precio; });
    var max = Math.max.apply(null, prices), min = Math.min.apply(null, prices);
    var best = ours <= min;
    if (box.getAttribute('data-only-cheaper') === 'true' && !best) { box.hidden = true; return; }
    var rows = offers.map(function (o) {
      var diff = o.precio > ours ? '<em class="pcmp-diff">+' + fmt(o.precio - ours) + '</em>' : '';
      return '<li class="pcmp-row"><span class="pcmp-store">' + esc(o.tienda) + '<small>' + esc(o.titulo) + '</small></span>' +
        '<span class="pcmp-price">' + fmt(o.precio) + diff + '</span>' +
        '<a class="pcmp-link" href="' + esc(o.url) + '" target="_blank" rel="nofollow noopener noreferrer" aria-label="Ver en ' + esc(o.tienda) + '">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg></a></li>';
    }).join('');
    box.innerHTML =
      '<div class="pcmp-head"><p class="pcmp-title">' + esc(box.getAttribute('data-heading')) + '</p>' +
      (ours < max ? '<span class="pcmp-save">Ahorras hasta <strong>' + fmt(max - ours) + '</strong></span>' : '') + '</div>' +
      '<ul class="pcmp-list"><li class="pcmp-row pcmp-row--ours"><span class="pcmp-store"><strong>' + esc(box.getAttribute('data-shop')) + '</strong>' +
      (best ? '<small>Mejor precio</small>' : '') + '</span><span class="pcmp-price">' + fmt(ours) + '</span></li>' + rows + '</ul>' +
      '<p class="pcmp-note">Productos similares en tiendas en línea, precios consultados hoy. Pueden variar en talla, material y disponibilidad.</p>';
    box.hidden = false;
  }

  fetch(url, { headers: { Authorization: 'Bearer ' + key, apikey: key } })
    .then(function (r) { return r.ok ? r.json() : { offers: [] }; })
    .then(function (data) {
      offers = (data && data.offers) || [];
      render(Number(box.getAttribute('data-ours')));
    })
    .catch(function () {});

  /* Al cambiar de talla se recalcula con el precio de esa talla */
  var sel = document.querySelector('[data-variant-select]');
  if (sel) sel.addEventListener('change', function () {
    var o = sel.options[sel.selectedIndex];
    if (o && o.dataset.priceCents && offers.length) render(Number(o.dataset.priceCents));
  });
})();

/* ---------- Carruseles con flechas ---------- */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-carousel]'), function (root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    function step(dir) {
      var item = track.firstElementChild;
      var w = item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
    }
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-carousel-prev]')) step(-1);
      else if (e.target.closest('[data-carousel-next]')) step(1);
    });
  });
})();

/* ---------- Pestañas de "Lo más vendido" ---------- */
(function () {
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-best-tab]');
    if (!tab) return;
    var root = tab.closest('.best');
    var i = tab.getAttribute('data-best-tab');
    Array.prototype.forEach.call(root.querySelectorAll('[data-best-tab]'), function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-best-panel]'), function (p) {
      p.hidden = p.getAttribute('data-best-panel') !== i;
      if (!p.hidden) Array.prototype.forEach.call(p.querySelectorAll('[data-reveal]'), function (el) { el.classList.add('is-in'); });
    });
  });
})();

/* ---------- Promociones: cuenta regresiva y copiar código ---------- */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-countdown]'), function (card) {
    var end = Number(card.getAttribute('data-countdown')) * 1000;
    var section = card.closest('.promo-hero');
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { if (section) section.hidden = true; clearInterval(t); return; }
      var s = Math.floor(left / 1000);
      var map = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      Object.keys(map).forEach(function (k) { var el = card.querySelector('[data-cd="' + k + '"]'); if (el) el.textContent = pad(map[k]); });
    }
    var t = setInterval(tick, 1000);
    tick();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var msg = b.querySelector('[data-copy-msg]');
    var done = function () { if (msg) { msg.textContent = 'Copiado'; setTimeout(function () { msg.textContent = 'Copiar'; }, 1800); } };
    if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute('data-copy')).then(done, done); else done();
  });
})();

/* ---------- Galería deslizante del producto ---------- */
(function () {
  Array.prototype.forEach.call(document.querySelectorAll('[data-gallery]'), function (root) {
    var track = root.querySelector('[data-gal-track]');
    var slides = root.querySelectorAll('[data-gal-slide]');
    var thumbs = root.querySelectorAll('[data-gal-go]');
    var cur = root.querySelector('[data-gal-current]');
    var prev = root.querySelector('[data-gal-prev]');
    var next = root.querySelector('[data-gal-next]');
    if (!track || slides.length < 2) return;
    var index = 0;

    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function mark(i) {
      if (i === index) return;
      index = i;
      if (cur) cur.textContent = i + 1;
      Array.prototype.forEach.call(thumbs, function (t, k) { t.classList.toggle('is-active', k === i); });
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    }, { passive: true });
    if (prev) { prev.disabled = true; prev.addEventListener('click', function () { go(index - 1); }); }
    if (next) next.addEventListener('click', function () { go(index + 1); });
    Array.prototype.forEach.call(thumbs, function (t) {
      t.addEventListener('click', function () { go(Number(t.getAttribute('data-gal-go'))); });
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });
  });
})();

/* ---------- TikTok: monta el reproductor solo cuando el video se acerca a la pantalla ---------- */
(function () {
  var frames = document.querySelectorAll('[data-ttk]');
  if (!frames.length) return;
  function mount(el) {
    if (el.querySelector('iframe')) return;
    var f = document.createElement('iframe');
    f.src = 'https://www.tiktok.com/player/v1/' + el.getAttribute('data-ttk') + '?music_info=0&description=0&rel=0&native_context_menu=0&closed_caption=0';
    f.title = 'Video de TikTok';
    f.loading = 'lazy';
    f.allow = 'encrypted-media; fullscreen; picture-in-picture';
    f.allowFullscreen = true;
    el.appendChild(f);
  }
  if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(frames, mount); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { mount(e.target); io.unobserve(e.target); }
    });
  }, { rootMargin: '200px' });
  Array.prototype.forEach.call(frames, function (el) { io.observe(el); });
})();

/* ---------- Selector de variantes con cuadritos de color ---------- */
(function () {
  var root = document.querySelector('[data-vpick]');
  var sel = document.querySelector('[data-variant-select]');
  if (!root || !sel) return;
  var opts = Array.prototype.slice.call(sel.options);
  var btns = Array.prototype.slice.call(root.querySelectorAll('[data-vpick-opt]'));
  var groups = btns.reduce(function (n, b) { return Math.max(n, Number(b.getAttribute('data-vpick-opt')) + 1); }, 0);
  function vals(o) { var a = []; for (var i = 0; i < groups; i++) a.push(o.getAttribute('data-o' + i)); return a; }
  var state = vals(sel.options[sel.selectedIndex]);
  function nice(v) { v = String(v || ''); return v.charAt(0) + v.slice(1).toLowerCase(); }
  function find(s, needAvail) {
    for (var i = 0; i < opts.length; i++) {
      var v = vals(opts[i]), ok = true;
      for (var g = 0; g < groups; g++) if (s[g] !== v[g]) { ok = false; break; }
      if (ok && (!needAvail || !opts[i].disabled)) return opts[i];
    }
    return null;
  }
  function paint() {
    btns.forEach(function (b) {
      var g = Number(b.getAttribute('data-vpick-opt')), v = b.getAttribute('data-value');
      var on = state[g] === v;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var test = state.slice(); test[g] = v;
      b.classList.toggle('is-out', !find(test, true));
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-vpick-label]'), function (l) {
      l.textContent = nice(state[Number(l.getAttribute('data-vpick-label'))]);
    });
  }
  function showImage(o) {
    var id = o && o.getAttribute('data-image');
    if (!id) return;
    var slide = document.querySelector('[data-image-id="' + id + '"]');
    if (!slide) return;
    var thumb = document.querySelector('[data-gal-go="' + slide.getAttribute('data-gal-slide') + '"]');
    if (thumb) thumb.click();
    else if (slide.parentNode) slide.parentNode.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-vpick-opt]');
    if (!b) return;
    var g = Number(b.getAttribute('data-vpick-opt'));
    state[g] = b.getAttribute('data-value');
    var o = find(state, true) || find(state, false);
    if (!o) {
      /* si la combinación no existe, toma la primera variante con el valor elegido */
      for (var i = 0; i < opts.length; i++) {
        if (vals(opts[i])[g] === state[g] && !opts[i].disabled) { o = opts[i]; break; }
      }
      if (o) state = vals(o);
    }
    if (o) {
      sel.value = o.value;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      showImage(o);
    }
    paint();
  });
  paint();
})();
